import { useClientPortalPublicData } from '../../hooks'

export const useOtherCriticalDates = () => {
  const { dataClientPortalPublic } = useClientPortalPublicData()

  const scheduledAlertsData = dataClientPortalPublic?.alertSchedule

  return { scheduledAlertsData }
}
